import { STATUS_TYPE } from '../../../enum';
import { Shape } from '../../shape/api/interface';

export interface ReadImageItems {
  shapeId: string;
  // sliced: string;
  top: string;
  front: string;
  shape: Shape;
}

export interface ImageItems {
  shapeId: string;
  // sliced: string;
  top: string;
  front: string;
}

export interface FindToppingsCategoryItem {
  toppingCategoryId?: string;
  limit?: number;
  skip?: number;
  search?: string;
  isExport?: boolean;
}

export interface GetToppingsCategoryItem {
  id: string;
}

export interface AdditionalToppingCategory {
  id: string;
  toppingItemId: string;
  toppingCategoryId: string;
  isActive: boolean;
  toppingCategory?: {
    id: string;
    labelEn: string;
    labelAr: string;
    position: number;
    activeState: boolean;
  };
}

export interface CreatePatchToppingsCategoryItem {
  id?: string;
  toppingCategoryId: string;
  additionalToppingCategoryIds?: string[];
  labelEn: string;
  labelAr: string;
  code: string;
  descriptionEn: string;
  descriptionAr: string;
  price: string;
  discountedPrice: string;
  effortScore?: number | string;
  previewUrl: string;
  position: string;
  shapeItems: ImageItems[];
  deliveryDayGap: string;
  // isNew: boolean;
  hasColor: boolean;
  isBig: boolean;
  activeState: boolean;
}

export interface ToppingsCategoryItem {
  id: string;
  toppingCategoryId: string;
  additionalToppingCategoryIds?: string[];
  allToppingCategoryIds?: string[];
  additionalCategories?: AdditionalToppingCategory[];
  labelEn: string;
  labelAr: string;
  code: string;
  descriptionEn: string;
  descriptionAr: string;
  price: string;
  discountedPrice: string;
  effortScore?: number | string;
  previewUrl: string;
  position: string;
  deliveryDayGap: string;
  toppingShapeImages: ReadImageItems[];
  // isNew: boolean;
  topping_category: {
    activeState: boolean;
    id: string;
    labelAr: string;
    labelEn: string;
  }
  hasColor: boolean;
  isBig: boolean;
  activeState: boolean;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
}

export interface InitialState {
  data: ToppingsCategoryItem[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
